import { useSelector } from 'react-redux';
import useAuth from '../../hooks/useAuth';
import { selectCurrentCustomerId } from './taxContextSlice';

export default function useTaxCustomer() {
  const { isGlobalAdmin, getAppAccess } = useAuth();
  const selected = useSelector(selectCurrentCustomerId);
  const access = getAppAccess?.('PAJAK_AUTOMATION');
  const value = Number(isGlobalAdmin ? selected : access?.scope?.customer_id);
  return Number.isInteger(value) && value > 0 ? value : null;
}
